<template>
    <v-card class="dev-mode-panel" elevation="4" v-if="enabled">
        <v-card-title class="dev-mode-header">
            <v-icon left color="orange">mdi-bug</v-icon>
            <span>Dev Mode</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
            <!-- State Control -->
            <div class="mb-4">
                <div class="text-subtitle-2 mb-2">Current State: <strong>{{ currentState }}</strong></div>
                <v-btn-toggle v-model="selectedState" mandatory class="flex-wrap">
                    <v-btn small value="idle">
                        <v-icon left x-small>mdi-qrcode-scan</v-icon>
                        Idle
                    </v-btn>
                    <v-btn small value="scanstart">
                        <v-icon left x-small>mdi-play</v-icon>
                        Scan Start
                    </v-btn>
                    <v-btn small value="error_slot">
                        <v-icon left x-small>mdi-alert</v-icon>
                        Error Slot
                    </v-btn>
                    <v-btn small value="error_article">
                        <v-icon left x-small>mdi-alert-octagon</v-icon>
                        Error Article
                    </v-btn>
                    <v-btn small value="success">
                        <v-icon left x-small>mdi-check-circle</v-icon>
                        Success
                    </v-btn>
                </v-btn-toggle>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- Article Data Simulation -->
            <div class="mb-4">
                <div class="text-subtitle-2 mb-2">Article Data</div>

                <!-- Preset Article Selector -->
                <v-select
                    v-model="selectedPreset"
                    :items="presetArticles"
                    item-text="label"
                    item-value="value"
                    label="Load Preset Article"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                    @change="loadPresetArticle"
                >
                    <template v-slot:prepend-inner>
                        <v-icon small color="primary">mdi-database</v-icon>
                    </template>
                </v-select>

                <v-text-field
                    v-model="mockArticle.orderId"
                    label="Order ID"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                ></v-text-field>
                <v-text-field
                    v-model="mockArticle.sku"
                    label="SKU"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                ></v-text-field>
                <v-text-field
                    v-model="mockArticle.slot"
                    label="Target Slot"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                ></v-text-field>
                <v-text-field
                    v-model="mockArticle.hashcode"
                    label="Hashcode"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                ></v-text-field>
                <v-textarea
                    v-model="mockArticle.printPreview"
                    label="Print Preview (Text or URL)"
                    dense
                    outlined
                    hide-details
                    rows="2"
                    class="mb-2"
                ></v-textarea>
            </div>

            <v-divider class="my-4"></v-divider>

            <v-alert type="info" dense text class="mb-4">
                <v-icon left small>mdi-information</v-icon>
                <small>Dev mode uses real backend APIs. It only simulates scanner input.</small>
            </v-alert>

            <!-- Scan Simulation -->
            <div class="mb-4">
                <div class="text-subtitle-2 mb-2">Simulate Scans</div>
                <v-btn
                    color="primary"
                    block
                    @click="simulateArticleScan"
                    class="mb-2"
                >
                    <v-icon left>mdi-barcode-scan</v-icon>
                    Scan Article
                </v-btn>
                <v-text-field
                    v-model="scannedSlot"
                    label="Shelf Slot to Scan"
                    dense
                    outlined
                    hide-details
                    class="mb-2"
                    placeholder="E.g., A1, W-A-15"
                ></v-text-field>
                <v-btn
                    color="secondary"
                    block
                    @click="simulateShelfScan"
                >
                    <v-icon left>mdi-qrcode-scan</v-icon>
                    Scan Shelf Slot
                </v-btn>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'DevModePanel',
    props: {
        enabled: {
            type: Boolean,
            default: false
        },
        currentState: {
            type: String,
            default: 'idle'
        }
    },
    data() {
        return {
            selectedState: 'idle',
            selectedPreset: null,
            presetArticles: [
                {
                    label: 'Acryl Nachtlicht D024 (MM32200)',
                    value: 'preset1',
                    data: {
                        orderId: 'MM32200',
                        sku: 'acryl_nachtlicht_D024',
                        slot: 'A1',
                        hashcode: '8721694065209462',
                        printPreview: 'https://cdn.teeinblue.com/designs/97980dbe-d90a-4e18-8324-3252790a0907/97980dbe-d90a-4e18-8324-3252790a0907-926648.png'
                    }
                },
                {
                    label: 'SF Leuchtturm - Emil (MM32320)',
                    value: 'preset2',
                    data: {
                        orderId: 'MM32320',
                        sku: 'SF_Leuchtturm',
                        slot: 'A1',
                        hashcode: '3219580913739914',
                        printPreview: 'Emil'
                    }
                },
                {
                    label: 'SF Autotransporter - Emil (MM32320)',
                    value: 'preset3',
                    data: {
                        orderId: 'MM32320',
                        sku: 'SF_Autotransporter',
                        slot: 'A1',
                        hashcode: '5974210987631768',
                        printPreview: 'Emil'
                    }
                },
                {
                    label: 'Acryl Nachtlicht D022 (MM32320)',
                    value: 'preset4',
                    data: {
                        orderId: 'MM32320',
                        sku: 'acryl_nachtlicht_D022',
                        slot: 'A1',
                        hashcode: '8297407103756051',
                        printPreview: 'https://cdn.teeinblue.com/designs/a5c98d8c-db93-4433-8732-57cb6e26cc96/a5c98d8c-db93-4433-8732-57cb6e26cc96-926130.png'
                    }
                }
            ],
            mockArticle: {
                orderId: 'MM32200',
                sku: 'acryl_nachtlicht_D024',
                slot: 'A1',
                hashcode: '8721694065209462',
                printPreview: 'https://cdn.teeinblue.com/designs/97980dbe-d90a-4e18-8324-3252790a0907/97980dbe-d90a-4e18-8324-3252790a0907-926648.png'
            },
            scannedSlot: 'A1'
        };
    },
    watch: {
        selectedState(newVal) {
            this.$emit('set-state', newVal);
        },
        currentState(newVal) {
            if (newVal !== this.selectedState) {
                this.selectedState = newVal;
            }
        }
    },
    methods: {
        loadPresetArticle() {
            const preset = this.presetArticles.find(p => p.value === this.selectedPreset);
            if (preset) {
                this.mockArticle = { ...preset.data };
                console.log('[DevMode] Loaded preset article:', preset.label);
            }
        },

        simulateArticleScan() {
            const scanData = {
                type: 'article',
                orderId: this.mockArticle.orderId,
                sku: this.mockArticle.sku,
                slot: this.mockArticle.slot,
                hashcode: this.mockArticle.hashcode
            };

            this.$emit('simulate-article-scan', {
                scanData,
                mockData: this.mockArticle
            });
        },

        simulateShelfScan() {
            const scanData = {
                type: 'shelf',
                slot: this.scannedSlot
            };

            this.$emit('simulate-shelf-scan', {
                scanData
            });
        }
    },
    mounted() {
        this.selectedState = this.currentState;
    }
};
</script>

<style scoped>
.dev-mode-panel {
    position: fixed;
    top: 80px;
    right: 20px;
    width: 380px;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    z-index: 1100;
    background: #fff3e0;
    border: 3px solid #ff9800;
}

.dev-mode-header {
    background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
    color: white;
    padding: 12px 16px;
}

.flex-wrap {
    flex-wrap: wrap;
}

/* Custom scrollbar */
.dev-mode-panel::-webkit-scrollbar {
    width: 6px;
}

.dev-mode-panel::-webkit-scrollbar-track {
    background: #ffe0b2;
}

.dev-mode-panel::-webkit-scrollbar-thumb {
    background: #ff9800;
    border-radius: 3px;
}

.dev-mode-panel::-webkit-scrollbar-thumb:hover {
    background: #f57c00;
}
</style>
